<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="$readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :pull="pull"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <vue-ueditor-wrap
      :config="useConfig"
      :style="styles"
      :value="value"
      @input="onInputChange"
    />
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'

export default {
  name: 'zpaRichTextInput',

  mixins: [inputMixin],

  computed: {
    useConfig() {
      const config = this.config
      config.zIndex = 2000
      config.UEDITOR_HOME_URL = process.env.NODE_ENV === 'production'
        ? '/fh/static/UEditor/' : '/static/UEditor/'
      return config
    },
  },

  props: {
    config: Object,
    styles: Object,
  },
}
</script>
